const Api = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    LOGIN: '/user/mobileLogin',
    FETCH_USER: '/user/info',
    LOAD_USER_INFO: '/user/userInfo',
    CHANGE_PASSWORD: '/user/changePassword',
    LOAD_DEVICE_BY_ASSET_NO: '/device/loadByAssetNo/',
    LIST_OTHER_USER: '/user/listOtherUser',
    LIST_ALL_USER: '/user/listAllUser',
    BORROW_DEVICE: '/device/borrow',
    MY_BORROW_HIS: '/borrowHis/myHisPage',
    APPLY_RETURN: '/borrowHis/applyReturn/',
    CONFIRM_RETURN: '/borrowHis/confirmReturn/',
    APPLY_TRANSFER: '/borrowHis/applyTransfer',
    MY_APPROVE_HIS: '/approveHis/myHisPage',
    APPROVE: '/approveHis/approve',
    AVAILABLE_DEVICE: '/device/availablePage',
    LIST_DEVICE_TYPE: '/device/type',
}
export default Api;